import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import TicketDetailsScreen from '../../components/tickets/TicketDetailsScreen';

const AllTicketsDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo || '/all-tickets';
  const { fetchTickets } = useApp();

  return (
    <TicketDetailsScreen
      backTo={returnTo}
      backLabel="Voltar aos tickets"
      onListUpdate={() => fetchTickets()}
      onResetSelection={() => navigate(returnTo)}
    />
  );
};

export default AllTicketsDetailPage;
